import { useTranslation } from "react-i18next";
import amplitude from "src/utils/amplitude";
export const useAnalytics = () => {
  const { i18n } = useTranslation();

  const init = () => {
    amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`, undefined, {
      minIdLength: 1,
      defaultTracking: {
        sessions: false,
        pageViews: false, // Manual tracking for better control
        formInteractions: false,
        fileDownloads: false

      },
    });
  };


  const setUserId = (user: any) => {
    amplitude.setUserId(user?.id);
  };

  const onlogin = () => {
    amplitude.track("Log-in", {
      page_current: "sign_in",
    }, { user_id: amplitude.getUserId(), language: i18n.language });
  };

  const onlogout = (data: any, user_id?: any) => {
    amplitude.track("Log-out", data, { user_id });
  };
  const track = (event: string, data?: any, options?: any) => {
    amplitude.track(event, data, {
      language: i18n.language,
      ...options
    });
  };

  return { init, setUserId, onlogin, track, onlogout };
};